import { Stack } from '@mui/system';
import { Typography } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { StyledEngineProvider } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

import theme from 'themes/wsp-theme';

import { ReactComponent as Logo } from './under-construction.svg';
// Initialize i18n for this standalone page
import '../../../@configurations/i18n';

const UnderConstruction = () => {
  const { t } = useTranslation();
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Stack spacing={4} height="90vh" display="flex" alignItems="center" justifyContent="center">
          <Logo style={{ height: '300px', width: '600px' }} />
          <Typography variant="h4">{t('underConstruction.launchingSoon')}</Typography>
        </Stack>
      </ThemeProvider>
    </StyledEngineProvider>
    
  );
}

export default UnderConstruction;